export const GOOGLE_PRODUCTS = {
  ANALYTICS: {
    REALPAGE_DEV_ACCOUNT: 'UA-100276633-3'
  },
  RECAPTCHA: {
    SITE_KEY: '6Lfwg-EqAAAAAGBM31hRg3l3WS5pjUG-9OBSAbQw'
  }
};



// WEBPACK FOOTER //
// ./src/environments/google-products.ts